// extracted by mini-css-extract-plugin
export default {"three":"SecThree_three__JKM7p"};